import React from "react"
import { Box } from "@mui/material"
import { reportListCellData } from "Pages/ReportsAlerts/Reports/@signals"
import ReportTableEditAction from "./edit"
import ReportTableForceAction from "./force"
import ReportTablePerformAction from "./perform"
import ReportTableCloneAction from "./clone"
import ReportTableInfoModalAction from "Pages/ReportsAlerts/Reports/@components/CrudTable/columns/actions/info"
import ReportTableDeleteAction from "./delete"

export default function actionsColumn() {
	return {
		name: "idReport", label: "Actions",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, rowData) => (
				<ActionsCell idReport={value} rowData={rowData}/>
			)
		}
	}
}

function ActionsCell({ idReport, rowData }) {
	const { statusLastExecution, ExecutionGlobalStatusCompleted, name } = { ...rowData, ...reportListCellData.value[rowData.idLastExecution] }
	const isRunningStatus = statusLastExecution === 'running' && !ExecutionGlobalStatusCompleted

	return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
		<ReportTablePerformAction isRunning={isRunningStatus} enabled={rowData.enabled} idReport={idReport} name={name}/>

		<ReportTableEditAction idReport={idReport} isRunning={isRunningStatus}/>

		<ReportTableCloneAction idReport={idReport} isRunning={isRunningStatus}/>

		<ReportTableInfoModalAction idReport={idReport}/>

		<ReportTableForceAction showForceButton={rowData.showForceButton}/>

		<ReportTableDeleteAction idReport={idReport} isRunning={isRunningStatus} name={rowData.name}/>
	</Box>
}
